<template>
    <div class="entry">
        <div class="imgBox">
            <img src="~@img/xueyezixun/consultant/growthFile/entry.png" alt=""/>
        </div>
        <div class="detail">
            <p>成长档案是学生参与学业咨询的全过程记录。</p>
            <p>记录了学生在整个学业咨询过程中的付出、成长与蜕变，包括了学生和家长共同参与的首次访谈、学生对未来的规划、每一次学业咨询中制定的目标、计划与复盘，每一次考试的进步，以及为升学做的竞赛、综合素质等所有努力。</p>
        </div>
        <div class="ftBtnBox" v-if="isHadGrowFile">
            <Button @handleClick="$router.push({path:'/studyPlan/growthFile/report',query:{id: id,userType:1}})" :type="'btnBlue'" name="查看档案" ></Button>
        </div>
        <div class="ftBtnBox2" v-else>
                <p>暂无成长档案，需联系咨询师生成~~！</p>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
export default {
    name: "entry",
    components: {
        Button
    },
    data() {
        return {
            isHadGrowFile:false,
            studentId: sessionStorage.getItem('myStudentStudentId'),
        }
    },
    created() {
       
    },
    mounted(){
         this.getLastGrowthFileId();
    },
    methods: {
        getLastGrowthFileId() {
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.student.student.growth.getLastGrowthFileIdByStudent, {
                studentId:studentId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if(data.code===2000) {
                    if(data.data.id>0) {
                        this.isHadGrowFile = true;
                        this.id = data.data.id;
                    }else {
                        this.isHadGrowFile = false;
                    }
                }
            })
        }
    },
}
</script>

<style scoped lang="less">
.entry {
    padding: 20px;
    background-color: #fff;
    img {
        display: block;
        width: 100%;
    }
    .detail {
        padding-top: 20px;
        p {
            line-height: 32px;
            text-indent: 2em;
        }
    }
    .ftBtnBox {
        padding: 35px 0;
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }
    .ftBtnBox2 {
        padding: 35px 0;
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }
}
</style>
